import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [getOverOccupy 설정 > 서버설정 > 프로세스 과점유 설정 > 프로세스 과점유 설정값을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getOverOccupy(params) {
    return axios.post(`${baseUrl}/settings/server-settings/over-occupy.do`, params);
  },
  /**
   * [getExceptProcess 설정 > 서버설정 > 프로세스 과점유 설정 > 과점유 예외 프로세스 목록을 가져온다]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getExceptProcess(params) {
    return axios.post(`${baseUrl}/settings/server-settings/except-process.do`, params);
  },
  /**
   * [getProcessList 설정 > 서버설정 > 프로세스 과점유 설정 > 예외 프로세스 추가 팝업 > 프로세스 항목을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getProcessList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/process-list.do`, params);
  },
  /**
   * [updateOverOccupy 설정 > 서버설정 > 프로세스 과점유 설정 > 프로세스 과점유 설정값을 수정한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateOverOccupy(params) {
    return axios.post(`${baseUrl}/settings/server-settings/update-occupy.do`, params);
  },
  /**
   * [updateExceptProcess 설정 > 서버설정 > 프로세스 과점유 설정 > 과점유 예외 프로세스 항목을 수정한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateExceptProcess(params) {
    return axios.post(`${baseUrl}/settings/server-settings/update-process.do`, params);
  },
  /**
   * [deleteExceptProcess 설정 > 서버설정 > 프로세스 과점유 설정 > 과점유 예외 프로세스 항목을 삭제한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteExceptProcess(params) {
    return axios.post(`${baseUrl}/settings/server-settings/delete-process.do`, params);
  },
  /**
   * [insertExceptProcess 설정 > 서버설정 > 프로세스 과점유 설정 > 과점유 예외 프로세스 항목을 추가한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertExceptProcess(params) {
    return axios.post(`${baseUrl}/settings/server-settings/insert-except-process.do`, params);
  },
  /**
   * [updateServicePortList 설정 > 포트설정 > 포트 인증/비인증 > 서비스 포트를 설정 또는 해제한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateServicePortList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/update-service-port-list.do`, params);
  },
  /**
   * [getServicePortList 설정 > 포트설정 > 포트 인증/비인증 > 서비스 포트 목록을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getServicePortList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-service-port-list.do`, params);
  },
  /**
   * [getPortScanCurList 설정 > 포트설정 > 포트 인증/비인증 > 인증/비인증 포트 목록을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getPortScanCurList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-portscan-cur.do`, params);
  },
  /**
   * [updatePortScanCurList 설정 > 포트설정 > 포트 인증/비인증 > 포트 항목을 인증 또는 비인증 처리한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updatePortScanCurList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/update-portscan-cur.do`, params);
  },
  /**
   * [getAgentCommandList 설정 > 명령어설정 > 명령어 목록을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAgentCommandList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-agent-command-list.do`, params);
  },
  /**
   * [insertAgentCommandList 설정 > 명령어설정 > 명령어 항목을 추가한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertAgentCommandList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/insert-agent-command-list.do`, params);
  },
  /**
   * [insertAgentCommandList 설정 > 명령어설정 > 명령어 항목을 수정한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateAgentCommandList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/update-agent-command-list.do`, params);
  },
  /**
   * [deleteAgentCommandList 설정 > 명령어설정 > 명령어 항목을 삭제한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteAgentCommandList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/delete-agent-command-list.do`, params);
  },
  /**
   * [getTargetDeviceList 환경 설정> 서버설정 > 명령어 설정 > 명령어 테스트 선택한 objtypeId와 일치하는 장비를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getTargetDeviceList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-target-device-list.do`, params);
  },
  /**
   * [getExecuteCLIResultByMap 환경 설정> 서버설정 > 명령어 설정 > 명령어 테스트를 결과를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getExecuteCLIResultByMap(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-execute-cli-result-by-map.do`, params);
  },
  /**
   * [getMajorProcessTreeList 서버 설정> 프로세스 설정 > 템플릿 설정 > 중요 프로세스 타입 트리를 가져온다.]
   * @author yelim
   * @return {[type]} [description]
   */
  getMajorProcessTreeList() {
    return axios.get(`${baseUrl}/settings/server-settings/get-major-process-tree-list.do`);
  },
  /**
   * [getMajorProcessList 서버 설정> 프로세스 설정 > 자동 프로세스 템플릿 목록을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getMajorProcessList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-major-process-list.do`, params);
  },
  /**
   * [insertMajorProcessList 서버 설정> 프로세스 설정 > 템플릿 설정 > 중요 프로세스 템플릿을 추가한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertMajorProcessList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/insert-major-process-list.do`, params);
  },
  /**
   * [updateMajorProcess 서버 설정> 프로세스 설정 > 템플릿 설정 > 중요 프로세스 템플릿을 수정한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateMajorProcess(params) {
    return axios.post(`${baseUrl}/settings/server-settings/update-major-process-list.do`, params);
  },
  /**
   * [deleteMajorProcess 서버 설정> 프로세스 설정 > 템플릿 설정 > 중요 프로세스 템플릿을 삭제한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteMajorProcess(params) {
    return axios.post(`${baseUrl}/settings/server-settings/delete-major-process-list.do`, params);
  },
  /**
   * [insertMajorProcessType 서버 설정> 프로세스 설정 > 템플릿 설정 > 중요 프로세스 타입을 추가한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertMajorProcessType(params) {
    return axios.post(`${baseUrl}/settings/server-settings/insert-major-proc-type.do`, params);
  },
  /**
   * [updateMajorProcessType 서버 설정> 프로세스 설정 > 템플릿 설정 > 중요 프로세스 타입을 수정한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateMajorProcessType(params) {
    return axios.post(`${baseUrl}/settings/server-settings/update-major-proc-type.do`, params);
  },
  /**
   * [deleteMajorProcessType 서버 설정> 프로세스 설정 > 템플릿 설정 > 중요 프로세스 타입을 삭제한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteMajorProcessType(params) {
    return axios.post(`${baseUrl}/settings/server-settings/delete-major-proc-type.do`, params);
  },
  /**
   * [getMajorProcessListByServer 서버 설정> 프로세스 설정 > 개별 등록 중요 프로세스 목록을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getMajorProcessListByServer(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-major-process-list-by-server.do`, params);
  },
  /**
   * [getAutoProcessByServer 서버 설정> 프로세스 설정 > 개별 등록 중요 자동 등록 프로세스 목록을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAutoProcessByServer(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-auto-process-by-server.do`, params);
  },
  /**
   * [getSettingProcessList 서버 설정> 프로세스 설정 > 개별 등록 중요 자동 등록 프로세스 목록을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSettingProcessList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-process-list.do`, params);
  },
  checkDuplicateMajorProc(params) {
    return axios.post(`${baseUrl}/settings/server-settings/check-duplicate-major-proc.do`, params);
  },
  /**
   * [insertIndivisualMajorProcess 서버 설정> 프로세스 설정 > 개별 등록 > 중요 프로세스 항목을 추가한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertIndivisualMajorProcess(params) {
    return axios.post(`${baseUrl}/settings/server-settings/insert-indivisual-major-process.do`, params);
  },
  /**
   * [deleteIndivisualMajorProcess 서버 설정> 프로세스 설정 > 개별 등록 > 중요 프로세스 항목을 삭제한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteIndivisualMajorProcess(params) {
    return axios.post(`${baseUrl}/settings/server-settings/delete-indivisual-major-process.do`, params);
  },
  /**
   * [updateIndivisualMajorProcess 서버 설정> 프로세스 설정 > 개별 등록 > 중요 프로세스 항목을 수정한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateIndivisualMajorProcess(params) {
    return axios.post(`${baseUrl}/settings/server-settings/update-indivisual-major-process.do`, params);
  },
  /**
   * [insertAutoProcess 서버 설정 > 프로세스 설정 > 개별 등록 > 자동 등폭 프로세스를 등록한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertAutoProcess(params) {
    return axios.post(`${baseUrl}/settings/server-settings/insert-auto-process.do`, params);
  },
  /**
   * [getServerProcessTree 서버 설정 > 프로세스 설정 > 일괄 등록 > 프로세스 검색 결과 트리를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getServerProcessTree(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-server-process-tree.do`, params);
  },
  /**
   * [insertMajorProcess 서버 설정 > 프로세스 설정 > 일괄 등록 > 주요 프로세스를 등록한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertMajorProcess(params) {
    return axios.post(`${baseUrl}/settings/server-settings/insert-major-process.do`, params);
  },
  /**
   * [getBulkFileDetectList 서버 설정 > 파일 감시 설정 > 대용량 파일 생성 감시 디렉토리 목록을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getBulkFileDetectList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-bulk-file-detect-list.do`, params);
  },
  /**
   * [insertBulkFileDetectDir 서버 설정 > 파일 감시 설정 > 감시 파일/디렉토리 중복 여부 확인.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkExistDetectFile(params) {
    return axios.post(`${baseUrl}/settings/server-settings/check-exist-detect-file.do`, params);
  },
  /**
   * [insertBulkFileDetectDir 서버 설정 > 파일 감시 설정 > 대용량 파일 생성 감시/ 파일 변경미변경 감시 항목을 추가한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertBulkFileDetectDir(params) {
    return axios.post(`${baseUrl}/settings/server-settings/insert-bulk-file-detect-dir.do`, params);
  },
  /**
   * [updateBulkFileDetectDir 서버 설정 > 파일 감시 설정 > 대용량 파일 생성 감시 디렉토리 항목을 수정한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateBulkFileDetectDir(params) {
    return axios.post(`${baseUrl}/settings/server-settings/update-bulk-file-detect-dir.do`, params);
  },
  /**
   * [deleteBulkFileDetectDir 서버 설정 > 파일 감시 설정 > 대용량 파일 생성 감시 디렉토리 항목을 삭제한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteBulkFileDetectDir(params) {
    return axios.post(`${baseUrl}/settings/server-settings/delete-bulk-file-detect-dir.do`, params);
  },
  /**
   * [getFileChangeDetectList 서버 설정 > 파일 감시 설정 > 파일 변경/미변경 감시 목록을 조회한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getFileChangeDetectList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-file-change-detect-list.do`, params);
  },
  /**
   * [insertDetectFilelistGroup 서버 설정 > 파일 감시 설정 > 파일 변경 / 미변경 감시 > 그룹 저장을 수행한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertDetectFilelistGroup(params) {
    return axios.post(`${baseUrl}/settings/server-settings/insert-file-change-detect-list.do`, params);
  },
  /**
   * [getPortControlList 서버 설정 > 보안 설정 > 차단 예외 설정 > 차단 포트 목록을 가져온다.]
   * @author yelim
   */
  getPortControlList(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-port-control-list.do`, params);
  },
  /**
   * [insertPortControl 서버 설정 > 보안 설정 > 포트 접근 허용 항목 또는 포트 접근 차단 항목을 추가한다.]
   * @author yelim
   */
  insertPortControl(params) {
    return axios.post(`${baseUrl}/settings/server-settings/insert-port-control.do`, params);
  },
  /**
   * [deletePortControl 서버 설정 > 보안 설정 > 포트 접근 허용 항목 또는 포트 접근 차단 항목을 삭제한다.]
   * @author yelim
   */
  deletePortControl(params) {
    return axios.post(`${baseUrl}/settings/server-settings/delete-port-control.do`, params);
  },
  /**
   * [updatePortControl 서버 설정 > 보안 설정 > 포트 접근 허용 항목 또는 포트 접근 차단 항목을 수정한다.]
   * @author yelim
   */
  updatePortControl(params) {
    return axios.post(`${baseUrl}/settings/server-settings/update-port-control.do`, params);
  },
  /**
   * [getPortControlAllow 서버 설정 > 보안 설정 > 차단 예외 설정 > 포트 접근 허용 목록을 가져온다.]
   * @author yelim
   */
  getPortControlAllow(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-port-control-allow.do`, params);
  },
  /**
   * [getPortControlAllow 서버 설정 > 보안 설정 > 차단 예외 설정 > 인증대상 목록을 가져온다.]
   * @author yelim
   */
  getPortcontrolAllowTarget(params) {
    return axios.post(`${baseUrl}/settings/server-settings/get-port-control-allow-target.do`, params);
  },
  /**
   * [insertPortcontrolAllow 서버 설정 > 보안 설정 > 차단 예외 설정 > 포트 접근 허용 항목을 추가한다.]
   * @author yelim
   */
  insertPortcontrolAllow(params) {
    return axios.post(`${baseUrl}/settings/server-settings/insert-port-control-allow.do`, params);
  },
  /**
   * [updatePortcontrolAllow 서버 설정 > 보안 설정 > 차단 예외 설정 > 포트 접근 허용 항목을 수정한다.]
   * @author yelim
   */
  updatePortcontrolAllow(params) {
    return axios.post(`${baseUrl}/settings/server-settings/update-port-control-allow.do`, params);
  },
  /**
   * [deletePortcontrolAllow 서버 설정 > 보안 설정 > 차단 예외 설정 > 포트 접근 허용 항목을 삭제한다.]
   * @author yelim
   */
  deletePortcontrolAllow(params) {
    return axios.post(`${baseUrl}/settings/server-settings/delete-port-control-allow.do`, params);
  },
  /**
   * 성능/운영분석 화면 / TCP/UDP 포트 리스트를 업데이트(삽입) 한다.
   * 포트 인증/비인증 탭
   * @author {Yang}
   * @param  {[data]} params [objID, saveList]
   * @return {[boolean  [success]
   */
  updateCertificationPort(params) {
    return axios.post(`${baseUrl}/performance/analysis/server/update-server-tcp-udp-settings-certification-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/server/server-settings.js